import React from 'react';
import CountOfTotal from '../../../../../components/CountOfTotal';
import Panel from '../../../../../components/outline/Panel';
import Img from '../../../../../components/Img';
import Button from '../../../../../components/Button';
import InfoForm from '../../../../../components/outline/InfoForm';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Slider from '../../../../../components/utils/Slider';
import { setDateFormat } from '../../../../../lib/moment';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  CS_INQUIRY_RESPONSE_BUTTON_TEXT,
  CS_INQUIRY_TYPE_TEXT,
  MAXIMUM_NUMBER_OF_INQUIRY_ANSWER_TEXT,
  MAXIMUM_NUMBER_OF_INQUIRY_MEMO_TEXT,
} from '../../../../../constants/service/app/csInquiryConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import './CsInquiryDetailInfo.scss';
import { ORDER_ITEM_STATUS_TEXT } from '../../../../../constants/service/app/orderConstants';
import { setDash } from '../../../../../lib/common';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';

const CsInquiryDetailInfo = (props) => {
  const { form, inquiryInfo, setData, onReply } = props;
  const {
    isResponse,
    attachments,
    type,
    createDate,
    question,
    answer,
    answerDate,
    memo,
    replyAuthor,
    orderItemId,
    orderItemStatus,
  } = inquiryInfo;

  return (
    <Panel className="cs-inquiry-detail-info">
      <div className="panel-header">
        <div className="title">문의 정보</div>

        <Button isRadius color="primary" onClick={() => onReply()} text={CS_INQUIRY_RESPONSE_BUTTON_TEXT[isResponse]} />
      </div>

      <div className="panel-body">
        <div className="inquiry-info-wrap">
          <div className="inquiry-images">
            <Slider
              className="inquiry-images-slider"
              emptyText="첨부 이미지가 없습니다."
              list={attachments}
              item={(url) => (
                <div className="inquiry-image">
                  <Img src={url} />
                </div>
              )}
            />
          </div>

          <div className="inquiry-info">
            <InfoForm className="inquiry-info-form">
              {/*문의 유형*/}
              <BaseForm label="문의 유형" content={CS_INQUIRY_TYPE_TEXT[type]} />

              {/*주문여부*/}
              <BaseForm
                label="주문여부"
                content={<OpenOrderItemDetail text={orderItemId} orderItemId={orderItemId} />}
              />

              {/*주문여부*/}
              <BaseForm label="주문상태" content={setDash(ORDER_ITEM_STATUS_TEXT[orderItemStatus])} />

              {/*질문 내용*/}
              <BaseForm label="질문 내용" content={question} />

              {/*질문 일시*/}
              <BaseForm label="질문 일시 " content={setDateFormat(createDate, DATE_FORMAT.FULL_DASH_FORMAT)} />

              {/*답변*/}
              <TextAreaForm
                form={form}
                label={
                  <span>
                    <span>답변</span>
                    <CountOfTotal content={answer} maxCnt={MAXIMUM_NUMBER_OF_INQUIRY_ANSWER_TEXT} />
                  </span>
                }
                rules={[formRequiredRules(true, '답변을 작성해주세요.')]}
                initialValue={answer}
                maxLength={MAXIMUM_NUMBER_OF_INQUIRY_ANSWER_TEXT}
                onChange={(value) =>
                  setData({
                    path: ['csInquiryDetail', 'inquiryInfo', 'answer'],
                    value,
                  })
                }
                name="answer"
                autoSize={{ minRows: 4, maxRows: 50 }}
              />

              {/*메모*/}
              <TextAreaForm
                form={form}
                label={
                  <span>
                    <span>메모</span>
                    <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_INQUIRY_MEMO_TEXT} />
                  </span>
                }
                rules={[formRequiredRules(true, '메모를 작성해주세요.')]}
                initialValue={memo}
                maxLength={MAXIMUM_NUMBER_OF_INQUIRY_MEMO_TEXT}
                onChange={(value) =>
                  setData({
                    path: ['csInquiryDetail', 'inquiryInfo', 'memo'],
                    value,
                  })
                }
                name="memo"
                autoSize={{ minRows: 4, maxRows: 50 }}
              />

              {/*답변 일자*/}
              <BaseForm label="답변 일자" content={setDateFormat(answerDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

              {/*답변 작성자*/}
              {replyAuthor ? <BaseForm label="답변 작성자" content={replyAuthor} /> : null}
            </InfoForm>
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default CsInquiryDetailInfo;
